<template>
    <div class="billsListBox">
        <avue-crud :data="data" :option="option" :page.sync='page'
                   @current-change='changePage' @size-change="sizeChange">
            <template  slot-scope="scope" slot="money">
                  <span>
              <span v-if="scope.row.add_or_sub == 1" style="color: #11b006"
              >+{{scope.row.money }}</span
              >
              <span v-if="scope.row.add_or_sub == 2" style="color: #FF0000"
              >-{{ scope.row.money }}</span
              >
            </span>
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { billList } from '@/api/personal';

export default {
    name: 'billsList',
    data() {
        return {
            listArgument: {
                limit: 10,
                page: 1
            },
            page: {
                currentPage: 1,
                total: 20,  //总数
                pageSize: 10  //每页条数
            },
            data: [],
            option: {
                stripe: true,
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuType: 'menu',
                menu:false,
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '账单ID',
                        prop: 'id'
                    }, {
                        label: '余额（元）',
                        prop: 'money'
                    }, {
                        label: '备注',
                        prop: 'remark'
                    }, {
                        label: '创建时间',
                        prop: 'create_time'
                    }
                ]
            }
        };
    },
    methods:{
        // 分页
        changePage(num){
            this.listArgument.page = num;
            billList(this.listArgument).then(res=>{
                this.data = res.data.list;
                this.page.total = res.data.count;
            })
        },
        // 切换每一页条数
        sizeChange(val){
            this.listArgument.limit = val;
            this.listArgument.page = 1;
            this.getList();
        },
        getList(){
            billList(this.listArgument).then(res=>{
                if (res.code==200){
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage=1
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped lang="scss">
    .billsListBox{
        background-color: #ffffff;
        padding: 20px;
        margin: 10px;
        border-radius: 5px;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
</style>